import React, { useState } from 'react';
import { Video, X } from 'lucide-react';

const VideoProduct = ({ title, description, price, imageUrl, youtubeId, stripeLink }) => {
  const [showTrailer, setShowTrailer] = useState(false);
  const [loading, setLoading] = useState(false);

  const handlePurchase = () => {
    if (stripeLink) {
      setLoading(true);
      window.location.href = stripeLink;
    } else {
      alert('Payment link not configured. Please add a Stripe payment link for this product.');
    }
  };

  return (
    <div className="product-card video-card">
      <div className="product-image-container">
        <img src={imageUrl} alt={title} className="product-image" />
        <div className="product-overlay">
          <button className="sample-btn" onClick={() => setShowTrailer(!showTrailer)}>
            <Video size={20} />
            Watch Trailer
          </button>
        </div>
      </div>
      <div className="product-content">
        <h3 className="product-title">{title}</h3>
        <p className="product-description">{description}</p>
        <div className="product-footer">
          <span className="product-price">${price}</span>
          <button 
            onClick={handlePurchase}
            disabled={loading}
            className="buy-btn"
          >
            {loading ? 'Loading...' : 'Buy Now'}
          </button>
        </div>
      </div>
      {showTrailer && (
        <div className="sample-modal" onClick={() => setShowTrailer(false)}>
          <div className="sample-content video-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowTrailer(false)}>
              <X size={24} />
            </button>
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${youtubeId}`}
              title="Video Trailer"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoProduct;
